import { render, staticRenderFns } from "./OrdersSearch.vue?vue&type=template&id=329957c8&"
import script from "./OrdersSearch.vue?vue&type=script&lang=js&"
export * from "./OrdersSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports